// "Lo más consultado por carrera": accesos recomendados que se muestran en el
// panel del dashboard según la carrera del alumno (cred.carrera).
//
// Es una configuración curada (sin backend). El día que la bitácora (audibita)
// exponga un agregado por carrera, este archivo se puede reemplazar por esa
// fuente sin tocar DashDestacados.js.
//
// Cada item: { to, icon, label, descripcion, externo }
//   externo: true  -> enlace externo (<a> target _blank)
//   externo: false -> ruta interna (react-router <Link>)

const COMUNES = [
    { to: '/erecursos', icon: 'fa-book', label: 'E-Recursos', descripcion: 'Bases de datos y revistas en línea' },
    { to: '/catalogo', icon: 'fa-search', label: 'Catálogo CCESEN', descripcion: 'Busca libros y material físico' },
    { to: '/notas', icon: 'fa-bar-chart', label: 'Notas', descripcion: 'Consulta tus calificaciones' },
];

const destacadosPorCarrera = {
    'Ingeniería de Negocios': [
        ...COMUNES,
        { to: '/tematicas', icon: 'fa-map-signs', label: 'Guías temáticas', descripcion: 'Recursos seleccionados de negocios' },
    ],
    'Economía y Negocios': [
        ...COMUNES,
        { to: '/tematicas', icon: 'fa-map-signs', label: 'Guías temáticas', descripcion: 'Recursos seleccionados de economía' },
    ],
    'Ciencias Jurídicas': [
        ...COMUNES,
        { to: '/tematicas', icon: 'fa-gavel', label: 'Guías jurídicas', descripcion: 'Legislación y jurisprudencia' },
    ],

    // Carreras de ingeniería (software / computación) y resto de perfiles.
    default: [
        ...COMUNES,
        { to: '/tematicas', icon: 'fa-map-signs', label: 'Guías temáticas', descripcion: 'Recursos seleccionados por área' },
    ],
};

// Devuelve la lista para una carrera, con respaldo en `default`.
export const destacadosDe = (carrera) =>
    destacadosPorCarrera[carrera] || destacadosPorCarrera.default;

export default destacadosPorCarrera;
